<template>
  <header class="header">
    <teleport to="body">
      <AuthModal @close="toggleModalAuth" v-if="isOpenModalAuth" />
    </teleport>
    <div class="container">
      <div class="header__wrapper">
        <div class="header__name-info">
          <nuxt-link class="header__logo-link" to="/">
            <DefIcon name="shar" />
          </nuxt-link>
          <div class="header__info">{{ $t('header.slogan') }}</div>

          <Search v-show="isOpenSearchForm" @close="isOpenSearchForm = false" />
        </div>
        <div class="header__controls">
          <!-- <div class="header__lang">
            <button
              v-for="loc in ['ru', 'en']"
              :key="loc"
              class="header__lang-btn"
              :class="{ 'header__lang-btn--active': locale === loc }"
              @click="switchLocale(loc)"
            >{{ loc.toUpperCase() }}</button>
          </div> -->
          <div class="header__icons">
            <button
              :class="[
                'header__btn header-search',
                { 'header-search--no-margin': isOpenSearchForm },
              ]"
              @click="openSearchForm"
            >
              <IconDef name="search"></IconDef>
            </button>
            <nuxt-link
              to="/basket"
              :class="[
                'header__btn header-basket',
                { 'header__btn--hide': isOpenSearchForm },
              ]"
            >
              <IconDef name="basket"></IconDef>
              <span class="header-basket__count" v-if="cartCount > 0">{{ cartCount }}</span>
            </nuxt-link>
            <div
              v-if="loadedUser"
              :class="['header__btn header-user', { 'header__btn--hide': isOpenSearchForm }]"
              ref="userMenuRef"
            >
              <!-- Гость → открываем модалку -->
              <button v-if="!isAuth" @click="toggleModalAuth" class="header-user__trigger">
                <IconDef name="user" />
              </button>

              <!-- Авторизован → выпадающее меню -->
              <template v-else>
                <button @click="isOpenUserMenu = !isOpenUserMenu" class="header-user__trigger">
                  <img v-if="userAvatar" :src="userAvatar" class="header-user__avatar" alt="" />
                  <IconDef v-else name="user" />
                </button>
                <div v-if="isOpenUserMenu" class="user-dropdown">
                  <a :href="`${mainSiteOrigin}/account`" class="user-dropdown__item" @click="isOpenUserMenu = false">
                    Аккаунт
                  </a>
                  <a :href="`${mainSiteOrigin}/orders`" class="user-dropdown__item" @click="isOpenUserMenu = false">
                    Заказы
                  </a>
                  <a :href="`${mainSiteOrigin}/requests`" class="user-dropdown__item" @click="isOpenUserMenu = false">
                    Запросы
                  </a>
                  <button class="user-dropdown__item user-dropdown__item--logout" @click="logout">
                    Выход
                  </button>
                </div>
              </template>
            </div>
          </div>
          <div class="header__menu menu" :class="{ isOpen: isOpen }">
            <button
              @click="toggleMenu"
              :class="[
                'menu__burger',
                { 'menu__burger--is-open-search': isOpenSearchForm },
              ]"
            >
              <span></span>
            </button>
            <div class="menu__content">
              <ul class="menu__list">
                <li
                  v-for="link in links"
                  :key="link.id"
                  class="menu__item"
                  :class="{ 'menu__item--catalog': link.path === '/catalog' }"
                  @mouseover="showCatalogMenu($event, link.path)"
                  @mouseleave="hideCatalogMenu"
                >
                  <a
                    :href="link.path"
                    @click="showCatalogMenu($event, link.path)"
                  >
                    {{ link.title }}
                  </a>
                  <CatalogMenu
                    v-if="link.path === '/catalog'"
                    :class="{ show: isShowCatalogMenu }"
                    :categories="categoriesTree"
                    @closeMenu="closeMenu"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import IconDef from "~/components/UI/IconDef.vue";
import DefIcon from "~/components/UI/Icons/DefIcon.vue";
import AuthModal from "~/components/Modals/AuthModal.vue";
import CatalogMenu from "~/components/Section/CatalogMenu.vue";
import { User } from "~/api/User.js";
import { Taxonomy } from "~/api/Taxonomy";
import { Taxonomy as TaxonomyEntity } from "~/dto/Taxonomy";
import Search from "~/components/System/Header/Search.vue";
import { UserService } from "~/services/UserService";
import { CartService } from "~/services/CartService";

const { locale, setLocale, t } = useI18n()

function switchLocale(loc: string) {
  setLocale(loc as 'ru' | 'en')
  if (import.meta.client) localStorage.setItem('locale', loc)
}

const isOpen = ref(false);
const isOpenModalAuth = ref(false);
const isOpenSearchForm = ref(false);
const isOpenUserMenu = ref(false);
const userMenuRef = ref<HTMLElement | null>(null);

const links = computed(() => [
  { id: 0, title: t('header.menu.home'),     path: "/" },
  { id: 1, title: 'Стиль',                   path: "/style" },
  { id: 2, title: 'Движение',               path: "/drive" },
  { id: 3, title: 'Пространство',            path: "/space" },
  { id: 4, title: 'Недвижимость',            path: "/realestate" },
]);
const loadedUser = ref(false);
const isAuth = ref(false);
const userAvatar = ref(null);
const isShowCatalogMenu = ref(false);
const cartCount = CartService.getInstance().count;
// Личный кабинет живёт только на sharun.store — с поддомена всегда уходим туда.
const mainSiteOrigin = computed(() =>
  import.meta.client && window.location.hostname === 'localhost'
    ? 'http://localhost:3000'
    : 'https://sharun.store'
);

const categoriesTree = ref<Array<TaxonomyEntity>>([]);

const searchInput = ref("");
const fastSearchItems = ref([]);

const openSearchForm = () => {
  isOpenSearchForm.value = true;

  console.log(isOpenSearchForm.value);
};

const toggleMenu = () => {
  if (isOpenSearchForm.value) {
    isOpenSearchForm.value = false;
    fastSearchItems.value = [];
    searchInput.value = "";
    return;
  }
  isOpen.value = !isOpen.value;
};

const toggleModalAuth = () => {
  isOpenModalAuth.value = !isOpenModalAuth.value;
};

const showCatalogMenu = (e, value) => {
  if (value === "/catalog") {
    isShowCatalogMenu.value = true;
    document.body.classList.add("no-scroll");

    if (e.type === "click" && window.innerWidth <= 1200) {
      e.preventDefault();
      isOpen.value = true;
    }
  } else {
    if (e.type === "click") isOpen.value = false;
  }
};

const hideCatalogMenu = () => {
  isShowCatalogMenu.value = false;
  document.body.classList.remove("no-scroll");
};

const closeMenu = () => {
  isOpen.value = false;
  document.body.classList.remove("no-scroll");
};

Taxonomy.getTree().then((tree) => (categoriesTree.value = tree));

async function loadUser() {
  const userService = UserService.getInstance();
  const user = await userService.getCurrent();
  if (user) {
    isAuth.value = true;
    userAvatar.value = user.avatar ?? null;
  }

  loadedUser.value = true;
}

function logout() {
  localStorage.removeItem('Id');
  localStorage.removeItem('Token');
  // Сессия шарится между *.sharun.store через cookie (SESSION_DOMAIN=.sharun.store,
  // не HttpOnly) — без этого пользователь мгновенно "залогинивался" обратно через
  // неё же на следующей загрузке страницы.
  document.cookie = 'Id=; Domain=.sharun.store; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT';
  document.cookie = 'Token=; Domain=.sharun.store; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT';
  window.location.href = '/';
}

function onClickOutside(e: MouseEvent) {
  if (userMenuRef.value && !userMenuRef.value.contains(e.target as Node)) {
    isOpenUserMenu.value = false;
  }
}

onMounted(() => {
  loadUser();
  CartService.getInstance().refresh();
  const saved = localStorage.getItem('locale')
  if (saved && saved !== locale.value) setLocale(saved as 'ru' | 'en')
  document.addEventListener('click', onClickOutside)
});

onUnmounted(() => {
  document.removeEventListener('click', onClickOutside)
});
</script>

<style scoped>
.header-basket {
  position: relative;
}
.header-basket__count {
  position: absolute;
  top: -0.6rem;
  right: -0.8rem;
  min-width: 1.8rem;
  height: 1.8rem;
  padding: 0 0.4rem;
  border-radius: 999px;
  background: #1b1918;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.8rem;
  text-align: center;
  pointer-events: none;
}

.header-user {
  position: relative;
}
.header-user__trigger {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-user__avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}
.user-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 160px;
  background: #fff;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(0,0,0,0.10);
  overflow: hidden;
  z-index: 200;
  display: flex;
  flex-direction: column;
}
.user-dropdown__item {
  display: block;
  padding: 12px 18px;
  font-size: 14px;
  color: #1a1a1a;
  text-decoration: none;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s;
  width: 100%;
}
.user-dropdown__item:hover {
  background: #f5f5f3;
}
.user-dropdown__item--logout {
  color: #999;
  border-top: 1px solid #f0f0f0;
  margin-top: 2px;
}
.header__lang {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-right: 12px;
}

.header__lang-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 5px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  border-radius: 3px;
  opacity: 0.35;
  color: inherit;
  transition: opacity 0.15s;
  font-family: inherit;

  &:hover { opacity: 0.65; }
  &--active { opacity: 1; }
}
</style>
